const chipsExpiredServices = {
  from: 'De',
  to: 'Até',
  mandatory: 'Serviços Obrigatórios',
  nonMandatory: 'Serviços Opcionais',
};

export default chipsExpiredServices;